import * as React from "react";
import Tabs from "../../components/tab/tabs";

function Price() {
  return (
    <div>
      <Tabs />
    </div>
  );
}

export default Price;
